import { Chip, Skeleton, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { useTranslation } from "react-i18next";
import { TbUserScan } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { passengerTypes } from "@/constants/passengerTypes";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { PassengerTypes } from "@/types/global";
import { IPlanPassenger } from "@/types/tasks.types";

export function PassengerTypeColumnCellSkeleton({ className }: { className?: string }) {
    return (
        <div className={`flex items-center py-1 h-[40px]  ${className || ""}`}>
            <Skeleton variant="rounded" width={70} height={25} className="!rounded-full" />
        </div>
    );
}
export function PassengerTypeColumnCell({ value, className }: { value: PassengerTypes; className?: string }) {
    const { t } = useTranslation();
    const status = passengerTypes.find((status) => status.value === value);
    return (
        <div className={`flex items-center py-1 h-full ${className || ""}`}>
            {status && (
                <NoMaxWidthTooltip
                    arrow
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 12,
                            maxWidth: "200px !important",
                        },
                    }}
                    title={<HotelStatusTooltip status={status} />}
                >
                    <Chip
                        sx={{
                            backgroundColor: status.bg,
                            color: status.text,
                            fontWeight: 500,
                            fontSize: "12px !important",
                        }}
                        icon={createElement(status.component(), {
                            fontSize: 14,
                            color: status.text,
                        })}
                        label={t(status.label || "")}
                    />
                </NoMaxWidthTooltip>
            )}
        </div>
    );
}

export const PassengerTypeColumn = ({ t }: { t: TFunction }): GridColDef<IPlanPassenger<"api">> => {
    return {
        field: "passengerType",
        headerName: t("passengerType"),
        minWidth: 140,
        valueGetter: (_val, row) => row.passengerType,
        renderHeader: (params) => <TableHeader Component={TbUserScan} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <PassengerTypeColumnCell value={value} />,
    };
};
export default PassengerTypeColumn;
